module.exports = __webpack_public_path__ + "img/home_sustainability_and_commitments.fe218a2d.png";